<template>
  <tag-entry
      :text="tag.name"
      :icon="tag.icon"
      :color="tag.color"
      :tag="tag"
      :showButtons="true"/>
</template>

<script>
import TagEntry from '@/components/sidebar/TagEntry.vue';

export default {
  name: 'CustomTagEntry',
  components: {
    TagEntry,
  },
  props: {
    tag: Object,
  },
};
</script>
